import { render } from "./CategoryResults.vue?vue&type=template&id=4f868d2a&scoped=true"
import script from "./CategoryResults.vue?vue&type=script&lang=js"
export * from "./CategoryResults.vue?vue&type=script&lang=js"

import "./CategoryResults.vue?vue&type=style&index=0&id=4f868d2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f868d2a"]])

export default __exports__